import type { RetryConfigTemplate } from 'src/interfaces/retryConfigTemplate'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getRetryConfigTemplates = (state: State): RetryConfigTemplate[] => {
  return state.retryConfigTemplate.templates
}

export const getRetryConfigTemplatesLoading = (state: State): boolean => {
  return state.retryConfigTemplate.loading
}

export const getRetryConfigTemplatesError = (state: State): string | null => {
  return state.retryConfigTemplate.error
}

export const getRetryConfigTemplateSaving = (state: State): boolean => {
  return state.retryConfigTemplate.saving
}
